import { Injectable, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { IUserInformation } from "../shared/user-information-overlay/user-information";
import { UserInformationOverlayComponent } from "../shared/user-information-overlay/user-information-overlay.component";
import { OverlayPopupService } from "../core/overlay-popup/overlay-popup.service";
import { DataService } from "../features/bucket-items/service/data.service";
import {
  BucketTypeConstants,
  ComponentConstants,
} from "../features/bucket-items/constants/component-constants";

@Injectable(
  {
    providedIn:'any'
  }
)
export class GenericExtensionsService{
  private readonly overlayPopupService = inject(OverlayPopupService);
  private readonly dataService = inject(DataService);


  private static readonly UPDATE_TAG_PERMISSION_BY_BUCKET_TYPE: Record<string, string> = {
    studydatacollection: 'sdc.updatetag',
    facilitydatacollection: 'fdc.updatetag',
    prearchive: 'pac.updatetag',
    facilityarchive: 'arc.updatetag',
  };
  
  private readonly _userInfo = toSignal(this.dataService.getUserInformation(),
    { initialValue: { Name: '', Email: '', IsActiveUser: false } as IUserInformation });
    public getBucketDisplayName(bucketName: string){
        switch(bucketName){
         case BucketTypeConstants.STUDYDATACOLLECTION:
           return ComponentConstants.STUDYDATACOLLECTION;
         case BucketTypeConstants.FACILITYDATACOLLECTION:
           return ComponentConstants.FACILITYDATACOLLECTION;
         case BucketTypeConstants.PREARCHIVE:
           return ComponentConstants.PREARCHIVE;
         case BucketTypeConstants.FACILITY_ARCHIVE:
           return ComponentConstants.FACILITYARCHIVE;
         default:
           return bucketName;  
        }
     }

  public static normalizeBucketType(bucketType?: string): string {
    return (bucketType || '').toLowerCase().replace(/[-_\s]/g, '');
  }

  public static getRequiredUpdateTagPermission(bucketType?: string): string | null {
    const normalizedBucketType = GenericExtensionsService.normalizeBucketType(bucketType);
    return GenericExtensionsService.UPDATE_TAG_PERMISSION_BY_BUCKET_TYPE[normalizedBucketType] || null;
  }
     

  formatBytes(bytes: number) {
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];

    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

public EllipsisLeft(text:string, chararaterLength: number):string{
  return text.length>chararaterLength ? `...${text.slice(text.length-(chararaterLength),text.length)}` : text;
}

public onInfoClick(e: any, userInfo?: IUserInformation): void {
  const info = userInfo ?? this._userInfo();
  if (info?.Name && info?.Email) {
    this.overlayPopupService.open(UserInformationOverlayComponent, {
      element: e,
      displayPointer: true,
      data: info,
      offsetStartX: 35,
      offsetStartY: 8,
    });
  }
}
  
  base64ToString(base64: string): string {
    const binaryString = atob(base64);

    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
  }
  
  extractBase64AndDecode(fullString: string): string {
    const base64Pattern = /^([A-Za-z0-9+/=]+)(.*)$/;
    const match = fullString.match(base64Pattern);
  
    if (!match) {
      throw new Error('No Base64 part found in the string');
    }
  
    const [_, base64Part, rest] = match;
    const decodedBase64 = this.base64ToString(base64Part);
    return `${decodedBase64}${rest}`;
  }

  addSpaceBeforeUpperCase(str: string): string {
    let result = '';
    for (let i = 0; i < str.length; i++) {
      if (i > 0 && str[i] === str[i].toUpperCase() && str[i] !== ' ') {
        result += ' ';
      }
      result += str[i];
    }
    return result;
  }
}
